import { v4 as uuidv4 } from 'uuid';
export  class Stage {
    name?: string;
    id?: string;
    label?: string;
    nickname?: string;
    section_title?: string;
    description?: string;
    condition_script?: string;
    jump_script?: string;
    price?: number;
    visible?:boolean;
    persist?:boolean;
    checkpoint?: boolean;
    constructor() {
        this.id = uuidv4();
    }
    validate(): boolean {
        return true;
    }
    calculatePrice(): void { }

    static createEmpty(): Stage {
        return new Stage();
    }

    has_some_script(): boolean {
        return this.condition_script !== '' || this.jump_script !== '';
    }
  }
  
export class WorkflowTemplate {
    id?: number;
    stages?: Stage[];
    name?: string;
    description?: string;
    default_doc_types?: string[];
    input_entity_type_uuid?: string;  // Renamed from trigger_entity_type_uuid
    output_entity_type_uuid?: string;  // New field

    constructor(id?: number, stages?: Stage[], name?: string, default_doc_types?: string[], input_entity_type_uuid?: string, description?: string, output_entity_type_uuid?: string) {
        this.id = id;
        this.stages = stages;
        this.name = name;
        this.default_doc_types = default_doc_types;
        this.input_entity_type_uuid = input_entity_type_uuid;
        this.description = description;
        this.output_entity_type_uuid = output_entity_type_uuid;
    }

    validate() : boolean {
        if (!this.stages || this.stages.length === 0) {
            return false;
        }
        return this.stages.every(stage => stage.validate());
    }
}

export class WaitForApproval extends Stage {
    static need_detail=true;
    name: string = 'WaitForApproval';
    username?: string;
    username_location?: string;
  
    constructor(username: string = '', username_location:string= '',price: number=0, visible:boolean=true, persist:boolean=true,checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super(); // Call the parent class's constructor
        this.username = username;
        this.username_location = username_location;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
        this.section_title=section_title;
        this.description=description;
    }
    validate(): boolean {
        return this.username !== '' || this.username_location !== '';
    }
    static createEmpty() {
        return new WaitForApproval();
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class UploadAsInvoice extends Stage {
    static need_detail=false;
    name: string = 'UploadAsInvoice';

    constructor(price: number = 0,visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label = label;
        this.nickname = nickname;
        this.section_title=section_title;
        this.description=description;
        this.section_title = section_title;
        this.description = description;
    }
    validate(): boolean {
        return true;
    }
    static createEmpty() {
        return new UploadAsInvoice();
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class ExtractTextFromDocument extends Stage {
    static need_detail=false;
    name: string = 'ExtractTextFromDocument';

    constructor(price: number = 0,visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label = label;
        this.nickname = nickname;
        this.section_title = section_title;
        this.description = description;
    }
    validate(): boolean {
        return true;
    }
    static createEmpty() {
        return new ExtractTextFromDocument();
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class AddDocumentRepresentationToConversation extends Stage {
    static need_detail=true;
    name:string = 'AddDocumentRepresentationToConversation';
    conversation?: string;
    input_mode?:string;
    crop?: boolean;
    headPages?:number;
    tailPages?:number;
    textFormat?:string;
    media_path?: string;

    constructor(conversation: string = '', input_mode:string='image', crop:boolean=true, headPages:number=1, tailPages:number=1, textFormat:string='lmdx', media_path:string='',price: number = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.conversation = conversation;
        this.input_mode = input_mode;
        this.crop = crop;
        this.headPages = headPages;
        this.tailPages = tailPages;
        this.textFormat = textFormat;
        this.media_path = media_path;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
        this.section_title=section_title;
        this.description=description;
    }

    validate(): boolean {
        return this.conversation !== '';
    }

    static createEmpty() {
        return new AddDocumentRepresentationToConversation();
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

export class AskAI extends Stage {
    static need_detail=true;
    name: string = 'AskAI';
    save_as_key?: string;
    entity_type_id?: string;
    prompt?: string;
    input_mode?:string;
    cheap?: boolean;
    reason?: boolean;
    cache?: boolean;
    crop?: boolean;
    headPages?:number;
    tailPages?:number;
    textFormat?:string;
    multitool?:boolean;
    forced_tool?:string;
    media_path?: string;

    constructor(save_as_key: string='', entity_type_id: string='', prompt: string='', input_mode:string='text', cheap: boolean = false, reason: boolean = false, cache: boolean = false, crop: boolean = true, headPages:number = 1, tailPages:number = 1, textFormat:string='lmdx', multitool:boolean=false, forced_tool:string='', media_path:string='',price:number = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.save_as_key = save_as_key;
        this.entity_type_id = entity_type_id;
        this.prompt = prompt;
        this.input_mode = input_mode;
        this.cheap = cheap;
        this.reason = reason;
        this.cache = cache;
        this.crop = crop;
        this.headPages = headPages;
        this.tailPages = tailPages;
        this.textFormat = textFormat;
        this.multitool = multitool;
        this.forced_tool = forced_tool;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
        this.media_path = media_path;
        this.section_title=section_title;
        this.description=description;
    }

    validate(): boolean {
        return this.save_as_key !== '';
    }
    static createEmpty() {
        return new AskAI();
    }
    calculatePrice(): void {
        let base_price = 2;
        // const priceModifiers = [
        //     { condition: !this.cheap, increment: 2 },
        //     { condition: this.reason, increment: 2 },
        //     { condition: this.prompt.length > 100, increment: 2 },
        //     { condition: this.classic_render, increment: 2 },
        // ];

        // priceModifiers.forEach(modifier => {
        //     if (modifier.condition) {
        //         base_price += modifier.increment;
        //     }
        // });
        this.price = base_price;
    }

    hasNestedObjects(obj: object): boolean {
        return Object.values(obj).some(value => typeof value === 'object' && value !== null);
    }
}


export class LookupAndMatchInstance extends Stage {
    static need_detail=true;
    name = 'LookupAndMatchInstance';
    entity_type_id?: string;
    destination_match_key?: string;
    origin_match_key?: string;
    save_as_key?: string;
    

    constructor(entity_type_id: string = '', destination_match_key: string = '', origin_match_key: string = '', save_as_key: string = '', price:number = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.destination_match_key = destination_match_key;
        this.origin_match_key = origin_match_key;
        this.save_as_key = save_as_key;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }
    static createEmpty() {
        return new LookupAndMatchInstance();
    }
    validate() : boolean {
        return this.entity_type_id !== '' && this.destination_match_key !== '' && this.origin_match_key !== '' && this.save_as_key !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class LookupAndMatchMultipleInstances extends Stage {
    static need_detail=true;
    name = 'LookupAndMatchMultipleInstances';
    entity_type_id?: string;
    destination_match_key?: string;
    origin_match_key?: string;
    save_list_key?: string;
    

    constructor(entity_type_id: string = '', destination_match_key: string = '', origin_match_key: string = '', save_list_key: string = '', price:number = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.destination_match_key = destination_match_key;
        this.origin_match_key = origin_match_key;
        this.save_list_key = save_list_key;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }
    static createEmpty() {
        return new LookupAndMatchMultipleInstances();
    }
    validate() : boolean {
        return this.entity_type_id !== '' && this.save_list_key !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class SendThroughEmail extends Stage {
    static need_detail=true;
    name = 'SendThroughEmail';
    email_location?: string;
    subject?: string;
    body?: string;

    constructor(email_location: string = '', subject: string = '', body: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.email_location = email_location;
        this.subject = subject;
        this.body = body;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new SendThroughEmail();
    }
    validate() : boolean {
        return this.email_location !== '' && this.subject !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class SendEmailWithTemplate extends Stage {
    static need_detail=true;
    name = 'SendEmailWithTemplate';
    email_location?: string;
    template_code?: string;
    context_location?: string;

    constructor(email_location: string = '', template_code: string = '', context_location: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.email_location = email_location;
        this.template_code = template_code;
        this.context_location = context_location;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new SendEmailWithTemplate();
    }
    validate() : boolean {
        return this.email_location !== '' && this.template_code !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class SplitFile extends Stage {
    static need_detail=true;
    name = 'SplitFile';
    entity_type_id='plain-text'
    file_location?: string;
    list_of_intervals_location?: string;
    save_list_key?: string;

    constructor(file_location: string = '', list_of_intervals_location: string = '', save_list_key: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.file_location = file_location;
        this.list_of_intervals_location = list_of_intervals_location;
        this.save_list_key = save_list_key
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new SplitFile();
    }
    validate() : boolean {
        return this.file_location !== '' && this.list_of_intervals_location !== '' && this.save_list_key !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}


export class RunCommand extends Stage {
    static need_detail=true;
    name = 'RunCommand';
    cmd_name?: string;
    payload_location?: string;
    entity_type_id?: string;
    save_as_key?: string;

    constructor(cmd_name: string = '', payload_location: string = '', entity_type_id: string = '',save_as_key: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.cmd_name = cmd_name;
        this.payload_location = payload_location;
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new RunCommand();
    }
    validate() : boolean {
        return this.cmd_name !== '' && this.save_as_key !== '' && this.entity_type_id !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}
export class RunQuery extends Stage {
    static need_detail=true;
    name = 'RunQuery';
    query_name?: string;
    payload_location?: string;
    entity_type_id?: string;
    save_as_key?: string;

    constructor(query_name: string = '', payload_location: string = '', entity_type_id: string = '',save_as_key: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.query_name = query_name;
        this.payload_location = payload_location;
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new RunQuery();
    }
    validate() : boolean {
        return this.query_name !== '' && this.save_as_key !== '' && this.entity_type_id !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}

export class RunWorkflow extends Stage {
    static need_detail=true;
    name = 'RunWorkflow';
    workflow_template_id?: number;
    payload_location?: string;
    save_as_key?: string;
    entity_type_id?: string;
    iterate?: boolean;

    constructor(workflow_template_id: number = 0, payload_location: string = '',save_as_key: string = '', entity_type_id: string = "", iterate:boolean=false, price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.workflow_template_id = workflow_template_id;
        this.payload_location = payload_location;
        this.save_as_key = save_as_key
        this.entity_type_id = entity_type_id;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
        this.iterate = iterate;
    }

    static createEmpty() {
        return new RunWorkflow();
    }
    validate() : boolean {
        return this.workflow_template_id !== 0 && this.save_as_key !== '' && this.entity_type_id !== '';
    }
    calculatePrice(): void {
        this.price = 0;
    }
}
// export class PayrollAccounting extends Stage {
//     static need_detail=true;
//     name = 'PayrollAccounting';
//     accounting_date?: string;
//     worker_id?: string;
//     description?: string;
//     salary?: string;
//     total_social_security?: string;
//     social_security_expense?: string;
//     irpf?: string;
//     salary_account?: string;
//     total_social_security_account?: string;
//     social_security_expense_account?: string;
//     irpf_account?: string;
//     total_to_pay?: string;
//     cotizacion_paro?: string;
//     cotizacion_formacion?: string;
//     cotizacion_contingencias?: string;
//     recuperacion_liquido?: string;
//     pp_extra?: string;


//     constructor(accounting_date: string, worker_id: string, description: string, salary: string, total_social_security: string, social_security_expense: string, irpf: string, salary_account: string, total_social_security_account: string, social_security_expense_account: string, irpf_account: string, total_to_pay:string, cotizacion_paro: string, cotizacion_formacion: string, cotizacion_contingencias: string, recuperacion_liquido:string,pp_extra:string, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, nickname:string ="") {
//         super();
//         this.accounting_date = accounting_date;
//         this.worker_id = worker_id;
//         this.description = description;
//         this.salary = salary;
//         this.total_social_security = total_social_security;
//         this.social_security_expense = social_security_expense;
//         this.irpf = irpf;
//         this.salary_account = salary_account;
//         this.total_social_security_account = total_social_security_account;
//         this.social_security_expense_account = social_security_expense_account;
//         this.irpf_account = irpf_account;
//         this.total_to_pay = total_to_pay;
//         this.cotizacion_paro = cotizacion_paro;
//         this.cotizacion_formacion = cotizacion_formacion;
//         this.cotizacion_contingencias = cotizacion_contingencias;
//         this.recuperacion_liquido = recuperacion_liquido;
//         this.pp_extra = pp_extra;
//         this.price = price;
//         this.visible = visible
//         this.persist = persist
//         this.checkpoint = checkpoint;
//         this.condition_script = condition_script;
//         this.nickname = nickname;
        // this.section_title=section_title;
        // this.description=description;
//     }

//     static createEmpty() {
//         return new PayrollAccounting('', '', '', '', '', '', '', '', '', '', '', '','','','','','');
//     }
//     validate() : boolean {
//         return true;
//     }
//     calculatePrice(): void {
//         this.price = 0;
//     }
// }


export class SendDataToEndpoint extends Stage {
    static need_detail=true;
    name = 'SendDataToEndpoint';
    endpoint?: string;
    payload_location?:string;
    headers_location?: string;
    files_location?: string;
    entity_type_id?: string;
    save_as_key?: string;
    request_method?: string;
    persist_response?: boolean;

    constructor(endpoint: string = '', payload_location: string = '', headers_location: string = '', files_location: string = '', entity_type_id: string = '', save_as_key: string = '', price = 0, visible:boolean=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string ="", section_title: string = '', description: string = '', request_method:string = 'POST', persist_response:boolean= true) {
        super();
        this.endpoint = endpoint;
        this.payload_location = payload_location;
        this.headers_location = headers_location;
        this.files_location = files_location;
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
        this.request_method = request_method
        this.persist_response = persist_response
    }

    static createEmpty() {
        return new SendDataToEndpoint();
    }

    validate() : boolean {
        return this.endpoint !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

export class NotifyCounterpart extends Stage {
    static need_detail=false;
    name = 'NotifyCounterpart';

    constructor(price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new NotifyCounterpart();
    }

    validate() : boolean {
        return true;
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

export class CreateInstanceFromContext extends Stage {
    static need_detail=true;
    name = 'CreateInstanceFromContext';
    entity_type_id: string;
    save_as_key: string;
    payload_of_addresses: any;

    constructor(entity_type_id: string = '', save_as_key: string = '', payload_of_addresses: any = {}, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key;
        this.payload_of_addresses = payload_of_addresses;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new CreateInstanceFromContext();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.save_as_key !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }

}

export class CompleteConversation extends Stage {
    static need_detail=true;
    name = 'CompleteConversation';
    agent:string;
    force_tool:string;
    conversation:string;
    save_as_key:string;
    max_iterations:number;

    constructor(agent: string = '', save_as_key: string = '', force_tool: string = '',conversation: string = '', max_iterations: number = 10, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.agent = agent;
        this.force_tool = force_tool;
        this.conversation = conversation;
        this.save_as_key = save_as_key;
        this.max_iterations = max_iterations;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new CompleteConversation();
    }

    validate() : boolean {
        return this.agent !== '' && this.save_as_key !== '' && this.conversation !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }

}

export class CreateInstance extends Stage {
    static need_detail=true;
    name = 'CreateInstance';
    entity_type_id: string;
    save_as_key: string;
    payload: any;

    constructor(entity_type_id: string = '', save_as_key: string = '', payload: any = {}, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key;
        this.payload = payload;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new CreateInstance();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.save_as_key !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }
}


export class AddInstanceToList extends Stage {
    static need_detail=true;
    name = 'AddInstanceToList';
    entity_type_id: string;
    list_location: string;
    payload_of_addresses: any;

    constructor(entity_type_id: string = '', list_location: string = '', payload_of_addresses: any = {}, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.list_location = list_location;
        this.payload_of_addresses = payload_of_addresses;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new AddInstanceToList();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.list_location !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }

}
export class CreateInstancesFromList extends Stage {
    static need_detail=true;
    name = 'CreateInstancesFromList';
    entity_type_id?: string;
    list_location?: string;
    payload_of_addresses?: any;
    save_list_key?: string;

    constructor(entity_type_id: string = '', list_location: string = '', payload_of_addresses: any = {}, save_list_key:string='',price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.list_location = list_location;
        this.save_list_key = save_list_key;
        this.payload_of_addresses = payload_of_addresses;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new CreateInstancesFromList();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.list_location !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }

}

export class ModifyContext extends Stage {
    static need_detail=true;
    name = 'ModifyContext';
    location_to_modify?: string;
    new_value_location?: string;

    constructor(location_to_modify: string, new_value_location: string, price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.location_to_modify = location_to_modify;
        this.new_value_location = new_value_location;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new ModifyContext('', '');
    }

    validate() : boolean {
        return this.location_to_modify !== '' && this.new_value_location !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }

}

export class ExtractInstanceFromRawData extends Stage {
    static need_detail=true;
    name = 'ExtractInstanceFromRawData';
    entity_type_id?: string;
    get_from_key?: string;
    save_as_key?: string;

    constructor(entity_type_id: string = '', get_from_key: string = '', save_as_key: string = '', price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.get_from_key = get_from_key;
        this.save_as_key = save_as_key;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new ExtractInstanceFromRawData();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.get_from_key !== '' && this.save_as_key !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

// @dataclass
// class RunScript(Stage):
//     name = 'RunScript'
//     entity_type_id:str
//     save_as_key:str
//     script:str
//     input_location:str
//     price:int = 0
//     visible:bool = True

export class RunScript extends Stage{
    static need_detail=true;
    name = 'RunScript';
    entity_type_id?: string;
    save_as_key?: string;
    script?: string;
    input_location?: string;

    constructor(entity_type_id: string = '', save_as_key: string = '', script: string = '', input_location: string = '', price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.entity_type_id = entity_type_id;
        this.save_as_key = save_as_key;
        this.script = script;
        this.input_location = input_location;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new RunScript();
    }

    validate() : boolean {
        return this.entity_type_id !== '' && this.save_as_key !== '' && this.script !== '' ;
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

export class DeleteContextInstance extends Stage {
    static need_detail=true;
    name = 'DeleteContextInstance';
    payload_location?: string;

    constructor(payload_location: string = '', price = 0, visible=true, persist:boolean=true, checkpoint:boolean=false, condition_script: string = '', jump_script: string = '', label: string = '', nickname:string = "", section_title: string = '', description: string = '') {
        super();
        this.payload_location = payload_location;
        this.price = price;
        this.visible = visible
        this.persist = persist
        this.checkpoint = checkpoint;
        this.condition_script = condition_script;
        this.jump_script = jump_script;
        this.label=label;
        this.nickname=nickname;
        this.section_title=section_title;
        this.description=description;
    }

    static createEmpty() {
        return new DeleteContextInstance();
    }

    validate() : boolean {
        return this.payload_location !== '';
    }

    calculatePrice(): void {
        this.price = 0;
    }
}

export const nameToClass = {
    'WaitForApproval': WaitForApproval, //
    'UploadAsInvoice': UploadAsInvoice,
    'AskAI': AskAI, //
    'LookupAndMatchInstance': LookupAndMatchInstance,
    'LookupAndMatchMultipleInstances': LookupAndMatchMultipleInstances,
    'CreateInstanceFromContext': CreateInstanceFromContext,
    'AddInstanceToList': AddInstanceToList,
    'CompleteConversation': CompleteConversation,
    'CreateInstance': CreateInstance, //
    'CreateInstancesFromList': CreateInstancesFromList,
    'ModifyContext': ModifyContext,
    'ExtractInstanceFromRawData': ExtractInstanceFromRawData,
    'SendThroughEmail': SendThroughEmail,  // 2
    'SendEmailWithTemplate': SendEmailWithTemplate,
    'SendDataToEndpoint': SendDataToEndpoint,
    'NotifyCounterpart': NotifyCounterpart,
    'RunScript': RunScript,
    'RunCommand': RunCommand,
    "RunQuery": RunQuery,
    "RunWorkflow": RunWorkflow,
    'AddDocumentRepresentationToConversation': AddDocumentRepresentationToConversation, // 2
    'SplitFile': SplitFile,
    'DeleteContextInstance': DeleteContextInstance,
    'ExtractTextFromDocument': ExtractTextFromDocument,
};

